import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/')({
  beforeLoad: ({ params: { siteId } }) => {
    throw redirect({
      to: '/n/sites/$siteId/overview',
      params: { siteId },
      replace: true,
    });
  },
});
